// Mirror api/app/services/credits/recalculate/quantitative.rb
export const QUANTITATIVE_RESPONDENTS_PER_CREDIT = 1000;
// Mirror api/app/services/credits/recalculate/qualitative.rb
export const QUALITATIVE_RESPONDENTS_PER_CREDIT = 20;

export const creditsLabel = (count) => (count === 1 ? "credit" : "credits");

export function getCreditRules({ aiChat, freemiumAccount = false }) {
  if (!aiChat) {
    return {
      respondentsPerCredit: QUANTITATIVE_RESPONDENTS_PER_CREDIT,
      stepperIncrement: 1,
      ruleLabel: "1 credit = 1,000 respondents",
    };
  }

  if (freemiumAccount) {
    return {
      respondentsPerCredit: QUALITATIVE_RESPONDENTS_PER_CREDIT,
      stepperIncrement: 1,
      ruleLabel: "1 credit = 20 respondents",
    };
  }

  return {
    respondentsPerCredit: QUALITATIVE_RESPONDENTS_PER_CREDIT,
    stepperIncrement: 5,
    ruleLabel: "5 credits = 100 respondents",
  };
}
